import { defineEffect } from '../../../core/effect';
import { negateBank } from '../fx/negateBank';

/**
 * **発動の無効**（Issue #591 v1。指示書 `../direction/chain_negated.md`。キービジュアルは無い＝方向は人が決めた）。
 * 無効にされたカードを中央に大きく出し、**X 字の太い鎖**で縛って無効化の印を叩きつける。
 * 組み立ては効果の無効（`chain_disabled.js`）と共有（`../fx/negateBank.js`）。違うのは鎖の見た目だけ。
 */
export default defineEffect(negateBank({
  situation: 'chain_negated',
  role: 'effect',
  label: '発動の無効（X 字の太い鎖で縛って無効化の印）',
  color: '#d0142c',
  bind: 'negated',
}), 'chain_negated_effect.js');
